// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"69":"d4da7deeeb4b18d5cc09","245":"d8a5320c992bcceaa5f1","360":"b009330dca19e76e7021","453":"d419ed5d91f28e5fc730"}[chunkId] + ".js";
};